// 프롬프트 데이터를 직접 임포트
import promptsData from './prompts_final.json';

export const getPrompts = async (filters = {}) => {
  let filtered = promptsData;

  // 검색 필터링
  if (filters.search) {
    filtered = filtered.filter(prompt => 
      prompt.title.toLowerCase().includes(filters.search.toLowerCase()) ||
      prompt.content.toLowerCase().includes(filters.search.toLowerCase())
    );
  }

  // 카테고리 필터링
  if (filters.category) {
    filtered = filtered.filter(prompt => prompt.chapterId === filters.category);
  }

  // 태그 필터링
  if (filters.tags && filters.tags.length > 0) {
    filtered = filtered.filter(prompt => 
      filters.tags.some(tag => prompt.tags.includes(tag))
    );
  }

  // 정렬
  if (filters.sort) {
    filtered.sort((a, b) => {
      if (filters.sort === 'title') {
        return filters.order === 'DESC' ? b.title.localeCompare(a.title) : a.title.localeCompare(b.title);
      }
      if (filters.sort === 'created_at') {
        return filters.order === 'DESC' ? b.id - a.id : a.id - b.id;
      }
      return 0;
    });
  }

  // 페이지네이션
  const page = filters.page || 1;
  const limit = filters.limit || 20;
  const startIndex = (page - 1) * limit;
  const endIndex = startIndex + limit;
  const paginatedPrompts = filtered.slice(startIndex, endIndex);

  return {
    prompts: paginatedPrompts,
    pagination: {
      page,
      limit,
      total: filtered.length,
      pages: Math.ceil(filtered.length / limit)
    }
  };
};

export const getPromptById = async (id) => {
  return promptsData.find(prompt => prompt.id === id);
};

export const getCategories = async () => {
  const categories = [];
  const chapterMap = new Map();
  
  promptsData.forEach(prompt => {
    if (!chapterMap.has(prompt.chapterId)) {
      chapterMap.set(prompt.chapterId, {
        id: prompt.chapterId,
        name: prompt.chapterTitle,
        prompt_count: 0
      });
    }
    chapterMap.get(prompt.chapterId).prompt_count++;
  });
  
  return Array.from(chapterMap.values()).sort((a, b) => a.id - b.id);
};

export const getTags = async () => {
  const tagMap = new Map();
  
  promptsData.forEach(prompt => {
    prompt.tags.forEach(tag => {
      if (!tagMap.has(tag)) {
        tagMap.set(tag, {
          id: tag,
          name: tag,
          color: getRandomColor(),
          prompt_count: 0
        });
      }
      tagMap.get(tag).prompt_count++;
    });
  });
  
  return Array.from(tagMap.values()).sort((a, b) => b.prompt_count - a.prompt_count);
};

const getRandomColor = () => {
  const colors = ['#3B82F6', '#EF4444', '#10B981', '#8B5CF6', '#F59E0B', '#06B6D4', '#84CC16', '#6366F1'];
  return colors[Math.floor(Math.random() * colors.length)];
};